<template>
  <v-dialog v-model="internalDialog" max-width="500" persistent>
    <v-card>
      <v-card-title
        :style="
          'background-color: ' +
          this.$store.state.config.siteConfig.toolbar_colour
        "
        >Verify your identity</v-card-title
      >

      <v-card-text class="pa-0">
        <AvatarState
          avatarSize="102"
          icon="mdi-email-outline"
          iconSize="54"
          width="100%"
        >
          <template #title>Check your emails</template>
          <template #body>
            We’ve sent a 6-digit verification code to your email. Please enter
            the code below to continue.
          </template>
        </AvatarState>
        <v-otp-input
          v-model="otp"
          :length="6"
          :error="otpError && otpError.length > 0"
          autofocus
        />
        <div v-if="otpError" class="px-2 text-center text-error text-body-2">
          {{ otpError }}
        </div>
        <div class="pa-4 text-center">
          <v-btn
            v-if="countdown <= 0"
            variant="text"
            :color="'primary'"
            @click="resendOtp"
          >
            Resend code
          </v-btn>
          <em v-else class="text-body-2">
            Didn’t receive the code? Please check your spam or junk folder. You
            can resend the code after {{ countdown }} seconds.
          </em>
        </div>
        <v-divider></v-divider>
      </v-card-text>

      <v-card-actions class="justify-space-between">
        <v-btn color="#4D4D4D" variant="text" @click="closeDialog">
          Cancel
        </v-btn>
        <v-btn
          variant="flat"
          :color="disableSubmit ? '#B5B5B5' : 'primary'"
          @click="submitOtp"
          :disabled="disableSubmit"
        >
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AvatarState from "@/components/AvatarState.vue";

export default {
  name: "OTP",
  components: {
    AvatarState,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      otp: "",
      otpError: null,
      timer: null,
      countdown: 60,
    };
  },
  computed: {
    internalDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    disableSubmit() {
      return this.otp.length !== 6;
    },
  },
  watch: {
    internalDialog(newVal) {
      if (newVal) {
        this.countdownTimer(); //start timer as dislog is open
      } else {
        //dialog closed - cleanup any timer
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
          this.otpError = null;
        }
      }
    },
    otp() {
      this.otpError = null;
    },
  },
  methods: {
    closeDialog() {
      this.internalDialog = false;
      this.otp = "";
    },
    submitOtp() {
      this.$axios
        .post("/twofa-verify", {
          email: this.email,
          otp: this.otp,
        })
        .then(() => {
          // successful OTP verification - emit event to parent to kick off login again
          this.$emit("twofa-verified");
          this.otaError = null;
          this.closeDialog();
        })
        .catch((error) => {
          switch (error.response.data.message) {
            case "invalid":
              this.otpError =
                "The code you entered is incorrect. Please check the code and try again.";
              break;
            case "expired":
              if (this.timer) {
                clearTimeout(this.timer);
              }
              this.countdown = 0;
              this.otpError =
                "This code has expired. Please request a new one to continue.";
              break;
            default:
              this.otpError =
                "There was an error validating code. Please try again";
          }
        });
    },
    resendOtp() {
      this.$axios
        .post("twofa-resend", { email: this.email })
        .then(() => {
          this.countdownTimer();
        })
        .catch((error) => {
          //handle generic error
          console.log(error);
        });
    },
    countdownTimer() {
      const duration = 60;

      this.countdown = duration;
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer);
        }
        this.countdown--;
      }, 1000);
    },
  },
};
</script>
